import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMount } from 'ahooks';

const DEFAULT_TAB = 'reports';

const TABS = [DEFAULT_TAB, 'true-data'];

export default function useContentManagementCenterActiveId(): [string, React.Dispatch<React.SetStateAction<string>>] {
  const location = useLocation();

  const [activeId, setActiveId] = useState(DEFAULT_TAB);

  useMount(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const lastPath = pathParts[pathParts.length - 1];

    if (TABS.includes(lastPath)) {
      setActiveId(lastPath);
    } else {
      setActiveId(DEFAULT_TAB);

      const newPathParts = [...pathParts];
      newPathParts[newPathParts.length - 1] = DEFAULT_TAB;
      const newPathname = `/${newPathParts.join('/')}`;

      history.replaceState(null, '', newPathname);
    }
  });

  return [activeId, setActiveId];
}
